import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../propTypes";
import { chartImageScaleFactor } from "../../constants";
import { downloadAnnotatedCsv, serializeSettings } from "../../data/csv";
import { withStyles } from "@material-ui/core";
import DownloadMenu from "../widgets/DownloadMenu";
import DownloadMenuButton from "../widgets/DownloadMenuButton";

const styles = {
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItem: "flex-start"
  }
};

const CountryExplorerChartTitle = props => {
  const [downloadMenuAnchorElement, setDownloadMenuAnchorElement] = useState();

  const handleClose = () => {
    setDownloadMenuAnchorElement(undefined);
  };

  return (
    <div>
      <div className={props.classes.toolbar}>
        <h3 className="section-heading">{props.children}</h3>

        <DownloadMenuButton
          onClick={e => {
            setDownloadMenuAnchorElement(e.target);
          }}
        />
      </div>

      <DownloadMenu
        anchorElement={downloadMenuAnchorElement}
        open={!!downloadMenuAnchorElement}
        onDownloadCsv={() => {
          let csv = props.chartRef.current.chart.getCSV();

          let settings = {
            indicator: props.indicatorId === 4 ? "Users" : "Cost",
            gniGroup: props.database.areas[props.areaId].area,
            method: props.methodId
              ? props.methodId === -2
                ? "Mix"
                : props.database.methods[props.methodId]
              : "All"
          };

          if (props.includeSectorSetting) {
            settings = {
              ...settings,
              sector: props.sectorId
                ? props.sectorId === -2
                  ? "Mix"
                  : props.database.sectors[props.sectorId]
                : "All"
            };
          }

          csv += serializeSettings(settings, true);

          downloadAnnotatedCsv(csv, `${props.fileStem}.csv`);

          handleClose();
        }}
        onDownloadPng={() => {
          props.chartRef.current.chart.exportChart({
            type: "image/png",
            filename: props.fileStem,
            scale: chartImageScaleFactor
          });

          handleClose();
        }}
        onClose={() => {
          handleClose();
        }}
      />
    </div>
  );
};

CountryExplorerChartTitle.propTypes = {
  children: PropTypes.string.isRequired,
  database: databasePropType.isRequired,
  indicatorId: PropTypes.number.isRequired,
  areaId: PropTypes.number.isRequired,
  methodId: PropTypes.number,
  sectorId: PropTypes.number,
  includeSectorSetting: PropTypes.bool,
  fileStem: PropTypes.string.isRequired,
  chartRef: PropTypes.object.isRequired
};

CountryExplorerChartTitle.defaultProps = {
  includeSectorSetting: true
};

export default withStyles(styles)(CountryExplorerChartTitle);
